export const styles = {
  mainContainer: "flex justify-end w-full max-h-10",
  form: "flex justify-between w-full bg-white border rounded-full shadow-sm xs:max-w-fit focus-within:border-zinc-500 py-1",
  searchInput: "border-none rounded-full focus:border-none focus:ring-0",
  clearBtn: "px-4 text-white bg-gray-400 border rounded-full hover:bg-gray-500",
};
